/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';

import { Chapter } from '../models/Chapter';
import { ResultsPartialChapterObjectId } from '../models/ResultsPartialChapterObjectId';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class ChapterApiResource {

    /**
     * Create a new chapter
     * 
     * @param body Chapter data to create
     */
    public createChapter(body?: Partial<Chapter>, axiosConfig?: AxiosRequestConfig): Promise<Chapter> {
        const reqPath = '/v1/chapter';
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return all chapters
     * 
     */
    public findChapters(axiosConfig?: AxiosRequestConfig): Promise<ResultsPartialChapterObjectId> {
        const reqPath = '/v1/chapter';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular chapter by id
     * 
     * @param chapterId Chapter id
     */
    public getChapter(chapterId: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<Chapter> {
        const reqPath = '/v1/chapter/{chapterId}'
                    .replace('{' + 'chapterId}', String(chapterId));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Update an existing chapter
     * 
     * @param chapterId Chapter id
     * @param body Chapter data to update
     */
    public updateChapter(chapterId: Partial<string>, body?: Partial<Chapter>, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/chapter/{chapterId}'
                    .replace('{' + 'chapterId}', String(chapterId));
        let reqConfig = {
            ...axiosConfig,
            method: 'PATCH',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }
    
}

export const ChapterApi = new ChapterApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/ChapterApi.ts